import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var _excluded = ["children"];
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import withApiData from '../services/withApiData';
import { getResultData } from '../redux/apiData';
import WishListCard from './WishListCard';
import MakeWishListCard from './MakeWishListCard';
import ContentLoader from './shared/ui/ContentLoader';
import Caret from './shared/icons/Caret';
import { fromBreakpoint, toBreakpoint } from '../styles/breakpoints';
import { CUBIC_TIMING, textStyles, colorPalette } from '../styles/styleGuide';
import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import partition from 'lodash.partition';
import ErrorBoundaryWithSentry from './atoms/ErrorBoundaryWithSentry';
var connectApiData = withApiData({
  wishLists: 'getWishLists'
}, function (ownProps) {
  return {
    wishLists: {
      projectSlug: ownProps.match.params.projectSlug
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    user: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'user', {})
  };
};
var Fade = function Fade(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return __jsx(CSSTransition, _extends({}, props, {
    timeout: 1000,
    classNames: "fade",
    "data-id": "components_WishListCollection_CSSTransition"
  }), children);
};
var WishListCollection = /*#__PURE__*/function (_Component) {
  function WishListCollection() {
    var _this;
    _classCallCheck(this, WishListCollection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WishListCollection, [].concat(args));
    _defineProperty(_this, "state", {
      items: [],
      itemsOwnBnr: [],
      itemsOtherBnr: [],
      loaded: false,
      expanded: false
    });
    _defineProperty(_this, "initializeItems", function (newProps, prevProps) {
      var user = newProps.user,
        wishLists = newProps.wishLists;
      if (wishLists.request.networkStatus === 'success' && !_this.state.loaded) {
        _this.setState({
          loaded: true
        });
      }
      if (wishLists.request.networkStatus === 'success' && !isEqual(newProps, prevProps)) {
        var partitionedWishlists = partition(wishLists.data, function (wishList) {
          return !user.customer || wishList.house.bnr === get(user, 'customer.bnr');
        });
        _this.setState({
          items: (partitionedWishlists[0] || []).concat({
            id: 0,
            type: 'newWishlist'
          }),
          itemsOwnBnr: partitionedWishlists[0],
          itemsOtherBnr: partitionedWishlists[1]
        });
      }
    });
    _defineProperty(_this, "expand", function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    });
    return _this;
  }
  _inherits(WishListCollection, _Component);
  return _createClass(WishListCollection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeItems(this.props, {});
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.initializeItems(this.props, prevProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        user = _this$props.user,
        priceListBlockId = _this$props.priceListBlockId;
      var _this$state = this.state,
        loaded = _this$state.loaded,
        items = _this$state.items,
        itemsOwnBnr = _this$state.itemsOwnBnr,
        itemsOtherBnr = _this$state.itemsOtherBnr,
        expanded = _this$state.expanded;
      return loaded ? __jsx(Container, {
        expanded: expanded,
        "data-e2e-block-wishlist-collection": true,
        "data-id": "components_WishListCollection_Container"
      }, __jsx(ErrorBoundaryWithSentry, {
        "data-id": "components_WishListCollection_ErrorBoundaryWithSentry"
      }, __jsx(TransitionGroup, {
        "data-id": "components_WishListCollection_TransitionGroup"
      }, items.map(function (item) {
        return __jsx(Fade, {
          key: item.id,
          "data-id": "components_WishListCollection_Fade"
        }, __jsx(Column, {
          "data-id": "components_WishListCollection_Column"
        }, item.type !== 'newWishlist' ? __jsx(WishListCard, {
          wishList: item,
          ownBNR: user.customer && user.customer.bnr ? user.customer.bnr : null,
          ownBNRWishlists: itemsOwnBnr.length,
          "data-id": "components_WishListCollection_WishListCard"
        }) : __jsx(MakeWishListCard, {
          priceListBlockId: priceListBlockId,
          "data-id": "components_WishListCollection_MakeWishListCard"
        })));
      })), user.customer && itemsOtherBnr.length > 0 && __jsx(Fragment, null, __jsx(Bar, {
        onClick: this.expand,
        "data-id": "components_WishListCollection_Bar"
      }, __jsx("div", {
        "data-id": "components_WishListCollection_div"
      }, __jsx(ExpansionTitle, {
        expanded: expanded,
        "data-id": "components_WishListCollection_ExpansionTitle"
      }, "Woonontwerpen voor de overige woningen (", itemsOtherBnr.length, ")"), __jsx(CaretContainer, {
        expanded: expanded,
        "data-id": "components_WishListCollection_CaretContainer"
      }, __jsx(Caret, {
        color: expanded ? colorPalette.darkBlue : colorPalette.blue,
        direction: "down",
        "data-id": "components_WishListCollection_Caret"
      })))), __jsx("div", {
        "data-id": "components_WishListCollection_div"
      }, __jsx(TransitionGroup, {
        "data-id": "components_WishListCollection_TransitionGroup"
      }, itemsOtherBnr.map(function (item) {
        return __jsx(Fade, {
          key: item.id,
          "data-id": "components_WishListCollection_Fade"
        }, __jsx(Column, {
          "data-id": "components_WishListCollection_Column"
        }, __jsx(WishListCard, {
          wishList: item,
          ownBNR: user.customer && user.customer.bnr ? user.customer.bnr : null,
          ownBNRWishlists: itemsOwnBnr.length,
          "data-id": "components_WishListCollection_WishListCard"
        })));
      })))))) : __jsx(Container, {
        "data-id": "components_WishListCollection_Container"
      }, __jsx(ContentLoader, {
        "data-id": "components_WishListCollection_ContentLoader"
      }));
    }
  }]);
}(Component);
export default withMatch(connectApiData(connect(mapStateToProps)(WishListCollection)));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  > div {\n    &:nth-of-type(1) {\n      display: flex;\n      width: 100%;\n      box-sizing: border-box;\n      flex-flow: row wrap;\n    }\n    &:nth-of-type(3) {\n      display: flex;\n      justify-content: center;\n      position: relative;\n      background-color: ", ";\n      width: 100vw;\n      left: calc(-50vw + 50%);\n      padding-bottom: ", "rem;\n      overflow: hidden;\n      height: ", ";\n\n      > div {\n        display: flex;\n        width: 1180rem;\n        box-sizing: border-box;\n        flex-flow: row wrap;\n        ", ";\n\n        > div {\n          opacity: ", ";\n          transition: opacity 0.25s ease-in-out;\n          transition-delay: 0.1s;\n        }\n      }\n    }\n  }\n\n  .fade-enter {\n    opacity: 0.01;\n  }\n\n  .fade-enter.fade-enter-active {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n    transition: all 1000ms ", ";\n  }\n\n  .fade-exit {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n\n  .fade-exit.fade-exit-active {\n    opacity: 0.01;\n    transform: translate3d(0, -30rem, 0);\n    transition: all 800ms ", ";\n  }\n"])), colorPalette.lightGrey, function (props) {
  return props.expanded ? 40 : 0;
}, function (props) {
  return !props.expanded ? 0 : "auto";
}, toBreakpoint.slg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          padding: 0 20px;\n        "]))), function (props) {
  return props.expanded ? 1 : 0;
}, CUBIC_TIMING, CUBIC_TIMING);
var Column = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  margin-bottom: 20rem;\n\n  ", ";\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: calc( ((1/2) * 100%) - 10rem );\n\n    &:nth-of-type(2n + 1) {\n      margin-right: 20rem;\n    }\n  "]))), fromBreakpoint.lg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: calc( ((1/3) * 100%) - 13.333rem );\n\n    &:nth-of-type(3n + 2) {\n      margin-right: 20rem;\n    }\n\n    &:nth-of-type(3n + 1) {\n      margin-right: 20rem;\n    }\n\n    &:nth-of-type(3n) {\n      margin-right: 0;\n    }\n  "]))));
var Bar = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  position: relative;\n  cursor: pointer;\n  background-color: ", ";\n  width: 100vw;\n  left: calc(-50vw + 50%);\n  margin-top: 40px;\n\n  > div {\n    width: 1180rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n    ", ";\n  }\n"])), colorPalette.lightGrey, toBreakpoint.slg(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      padding: 0 20px;\n    "]))));
var ExpansionTitle = styled.h3(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  transition: color 0.25s;\n"])), textStyles.sectionTitle, function (props) {
  return props.expanded ? colorPalette.darkBlue : colorPalette.blue;
});
var CaretContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  transform: rotateX(", "deg);\n  transition: transform 0.25s;\n  padding-left: 15rem;\n"])), function (props) {
  return props.expanded ? 180 : 0;
});